import { render, staticRenderFns } from "./remember.password.component.vue?vue&type=template&id=5efb5bf7"
import script from "./remember.password.component.vue?vue&type=script&lang=js"
export * from "./remember.password.component.vue?vue&type=script&lang=js"
import style0 from "./remember.password.component.vue?vue&type=style&index=0&id=5efb5bf7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports